function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { filterMixin } from '@/mixins/filter_mixin';
import { envConfig } from '@/js/constants';
import { localPaginationMixin } from '@/mixins/local_pagination';
import tasks from '@/js/tasks';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import PaginationCatalog from '@/components/PaginationCatalog.vue';
export default {
  name: 'TablesWithoutMetadataReportPage',
  components: {
    OrganizacionComponent: OrganizacionComponent,
    PaginationCatalog: PaginationCatalog
  },
  mixins: [filterMixin, localPaginationMixin],
  data: function data() {
    return {
      items: [],
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        offset: 0
      },
      pageSize: envConfig.pagintaionSize,
      nextToken: {},
      keyPagination: 1,
      keyTable: 1,
      domainFilter: null,
      dataFilter: {},
      showAsyncData: false
    };
  },
  created: function created() {
    this.domainFilter = this.userDomain;
    this.getTables(this.dataFilter);
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('monitoring.subtitle_no_metadata'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        text: this.translate('monitoring.tablas_monitoring.project'),
        value: 'tableReference.projectId',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.translate('monitoring.tablas_monitoring.dataset'),
        value: 'tableReference.datasetId',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.translate('monitoring.tablas_monitoring.table'),
        value: 'tableReference.tableId',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.translate('monitoring.tablas_monitoring.columns'),
        value: 'schema.fields.length',
        class: 'w-15',
        align: 'center'
      }, {
        text: this.translate('monitoring.tablas_monitoring.rows'),
        value: 'numRows',
        class: 'w-15 text-center',
        align: 'center'
      }, {
        text: this.translate('monitoring.tablas_monitoring.actions'),
        value: 'actions',
        class: 'w-15 text-center',
        align: 'center'
      }];
    }
  }),
  methods: {
    getTables: function getTables() {
      var _this = this;
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      console.log("Page size: ".concat(this.pageSize));
      this.showAsyncData = false;
      var params = {
        nextToken: this.nextToken,
        pageSize: this.pageSize,
        projects: this.projects,
        catalogs: this.catalogs
      };
      if (conditions) {
        params['conditions'] = this.dataFilter;
      }
      TablesService.getTablesWithoutMetadata(params).then(function (response) {
        if (response.data.next_page_token && Object.keys(response.data.next_page_token).length > 0) {
          if (!_this.pagination.tokens) {
            _this.pagination.tokens = {};
          }
          _this.pagination.tokens[_this.pagination.current + 1] = response.data.next_page_token;
          _this.pagination.next_page_token = response.data.next_page_token;
        } else {
          _this.pagination.next_page_token = {};
        }
        _this.keyPagination += 1;
        _this.items = response.data.tables;
      }).then(function () {
        if (_this.items.length) {
          _this.getDetails();
        }
      });
    },
    getDetails: function getDetails() {
      var _this2 = this;
      var tables = [];
      this.items.forEach(function (item) {
        tables.push({
          projectId: item.tableReference.projectId,
          datasetId: item.tableReference.datasetId,
          tableId: item.tableReference.tableId,
          domain_table: item.domain_table,
          source: item.source ? item.source : "bigquery"
        });
      });
      var params = {
        tables: tables
      };
      AssignmentsService.getTablesDetails(params).then(function (response2) {
        if (response2.data) {
          var _loop = function _loop(key) {
            var items = _this2.items.filter(function (item) {
              return item.id === response2.data[key].id;
            });
            items.forEach(function (y) {
              var ole = _objectSpread(_objectSpread({}, y), response2.data[key]);
              var index = _this2.items.indexOf(y);
              if (index !== -1) {
                _this2.items[index] = ole;
              }
            });
          };
          for (var key in response2.data) {
            _loop(key);
          }
          _this2.keyTable += 1;
          _this2.showAsyncData = true;
        }
      });
    },
    changePage: function changePage(page) {
      console.log(page, this.pagination.tokens);
      if (page === 1) {
        this.nextToken = {};
        this.pagination.tokens = null;
        this.pagination.next_page_token = {};
      } else {
        this.nextToken = this.pagination.tokens[page];
      }
      this.getTables(this.dataFilter);
    },
    onCleanSearch: function onCleanSearch() {
      this.dataFilter = {};
      this.getTables();
    },
    onSearch: function onSearch() {
      this.getTables(this.dataFilter);
    },
    syncTable: function syncTable(item) {
      var _this3 = this;
      var tableReference = item.tableReference;
      var params = {
        project_id: tableReference.projectId,
        dataset_id: tableReference.datasetId,
        table_id: tableReference.tableId
      };
      TablesService.syncTable(params).then(function (response) {
        if (response.success) {
          tasks.toast.success(response.message, _this3.translate('titles.success'));
        } else {
          tasks.toast.error(_this3.translate('error_messages.error_general'));
        }
        _this3.getTables(_this3.dataFilter);
      });
    },
    onDownloadCSV: function onDownloadCSV() {
      var columns = ['projectId', 'datasetId', 'table', 'columns', 'rows'];
      var body = [columns.join(';')];
      var rows = [];
      var _iterator = _createForOfIteratorHelper(this.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          rows.push({
            projectId: item.tableReference.projectId,
            datasetId: item.tableReference.datasetId,
            table: item.tableReference.tableId,
            columns: item.schema.fields.length,
            rows: item.numRows
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var row = [];
      for (var _i = 0, _rows = rows; _i < _rows.length; _i++) {
        var record = _rows[_i];
        var _iterator2 = _createForOfIteratorHelper(columns),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var column = _step2.value;
            row.push(record[column]);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        row = row.join(';');
        body.push(row);
        row = [];
      }
      var data = body.join('\n');
      var fileName = 'Tables-without-metadata';
      tasks.saveData(data, fileName);
    }
  }
};